module.exports = "\n<div class=\"swiper-slide\">\n    <slot></slot>\n</div>\n";